// extracted by mini-css-extract-plugin
module.exports = {"red":"antd-pro-modules-after-sale-components-focus-label-index-red"};